import { render, staticRenderFns } from "./StoryMaker.vue?vue&type=template&id=5fa72314&scoped=true&"
import script from "./StoryMaker.vue?vue&type=script&lang=js&"
export * from "./StoryMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa72314",
  null
  
)

export default component.exports